// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'price',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'hotel',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'hotel_room',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'description',
    label: '',
    Object: 'value',
    width: '150'
  }]
}
